var _link, _style, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfArkansas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf0a30"
    },
    d: "M0 0h450v300H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 148.84 224.225 275 412.5 148.595 224.225 25 37.5 148.84z",
    style: {
      fill: "#002868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 149.128 224.417 244 366 148.944 224.417 56 84 149.128z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.175 145.014h7.835l1.36 4.376h4.82l-7.48-21.228h-5.116l-7.568 21.228h4.671l1.478-4.376zm3.903-12.063h.059l2.631 8.397h-5.41l2.72-8.397zm12.97 16.439h4.345v-8.308h4.583c1.58-.014 2.566.294 2.96.924.394.63.56 1.661.499 3.097.001 1.073.043 1.935.126 2.587.082.651.198 1.218.347 1.7h4.908v-.562c-.454-.138-.73-.498-.828-1.083-.099-.585-.138-1.633-.118-3.145-.003-1.91-.234-3.205-.691-3.888-.458-.682-1.124-1.18-2-1.493 1.055-.375 1.865-1.014 2.428-1.918.564-.903.848-1.95.854-3.138.022-.65-.137-1.44-.477-2.37-.34-.93-.995-1.757-1.963-2.483-.967-.725-2.381-1.108-4.242-1.148h-10.732v21.228zm4.345-11.886v-5.676h5.529c1.268.045 2.11.368 2.528.968.417.6.61 1.204.576 1.811.001 1.04-.282 1.784-.85 2.236-.568.451-1.428.672-2.58.661h-5.203zm21.78 4.701 2.07-2.128 6.563 9.313h5.706l-9.165-12.536 8.662-8.692h-5.735l-8.101 8.633v-8.633h-4.435v21.228h4.435v-7.185zm21.1 2.809h7.834l1.36 4.376h4.82l-7.48-21.228h-5.115l-7.569 21.228h4.671l1.479-4.376zm3.902-12.063h.06l2.63 8.397h-5.41l2.72-8.397zm25.919 9.993h-.06l-8.425-14.782h-4.672v21.228h4.14v-15.138h.059l8.662 15.138h4.435v-21.228h-4.14v14.782zm7.322-.088c-.031.916.18 1.919.632 3.009.453 1.09 1.336 2.034 2.649 2.831 1.313.798 3.245 1.216 5.796 1.255.69.033 1.688-.095 2.997-.382 1.308-.287 2.513-.93 3.614-1.926 1.102-.997 1.687-2.543 1.756-4.64-.05-1.862-.615-3.2-1.693-4.017-1.078-.816-2.366-1.379-3.866-1.689l-5.174-1.27a4.085 4.085 0 0 1-1.456-.566c-.489-.298-.752-.848-.79-1.652.048-.947.453-1.611 1.215-1.992a5.272 5.272 0 0 1 2.48-.55c1.868.073 3.062.487 3.581 1.24.52.755.774 1.405.765 1.952h4.258c.009-.904-.23-1.882-.714-2.934-.485-1.053-1.33-1.961-2.534-2.725-1.205-.763-2.881-1.163-5.03-1.2-2.27.037-3.996.426-5.178 1.168s-1.981 1.616-2.398 2.62c-.417 1.006-.611 1.92-.585 2.746.067 2.254.762 3.777 2.085 4.571 1.323.794 2.875 1.35 4.656 1.667l2.277.532c1.143.24 2.064.537 2.764.895.7.357 1.06.936 1.08 1.737-.054 1.097-.531 1.836-1.431 2.217-.9.38-1.901.558-3.005.532-1.88-.069-3.109-.493-3.688-1.271-.579-.779-.847-1.498-.805-2.158h-4.258zm25.337 2.158h7.835l1.36 4.376h4.819l-7.48-21.228h-5.115l-7.569 21.228h4.672l1.478-4.376zm3.902-12.063h.06l2.63 8.397h-5.41l2.72-8.397zm11.876 9.905c-.032.916.179 1.919.632 3.009.452 1.09 1.335 2.034 2.648 2.831 1.314.798 3.246 1.216 5.796 1.255.69.033 1.689-.095 2.997-.382 1.309-.287 2.514-.93 3.615-1.926 1.101-.997 1.686-2.543 1.755-4.64-.05-1.862-.615-3.2-1.692-4.017-1.078-.816-2.367-1.379-3.866-1.689l-5.174-1.27a4.085 4.085 0 0 1-1.456-.566c-.49-.298-.753-.848-.79-1.652.048-.947.453-1.611 1.215-1.992a5.272 5.272 0 0 1 2.48-.55c1.868.073 3.062.487 3.58 1.24.52.755.775 1.405.766 1.952h4.257c.01-.904-.229-1.882-.714-2.934-.485-1.053-1.33-1.961-2.534-2.725-1.204-.763-2.88-1.163-5.03-1.2-2.27.037-3.995.426-5.177 1.168-1.182.742-1.982 1.616-2.398 2.62-.417 1.006-.612 1.92-.585 2.746.066 2.254.761 3.777 2.084 4.571 1.323.794 2.876 1.35 4.657 1.667l2.276.532c1.144.24 2.065.537 2.765.895.7.357 1.06.936 1.079 1.737-.054 1.097-.53 1.836-1.43 2.217-.9.38-1.902.558-3.005.532-1.88-.069-3.11-.493-3.688-1.271-.58-.779-.848-1.498-.806-2.158h-4.257z",
    style: {
      fontSize: 28,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      textAlign: "start",
      lineHeight: "125%",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#002868",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      fontFamily: "Helvetica LT Std",
      InkscapeFontSpecification: "Helvetica LT Std Bold"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.484 49.981-5.521-4L218.452 50l2.095-6.491-5.522-4.004 6.815-.012L223.94 33l2.118 6.484 6.818-.01-5.507 4.02 2.116 6.487z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.964 190 225 197.081l-9.976-7.075 3.81 11.453-9.966 7.088 12.319-.003L225.004 220l3.804-11.454 12.324-.009-9.968-7.076 3.8-11.461z",
    style: {
      fill: "#002868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.7 190-9.965-7.081-9.976 7.075 3.81-11.453-9.965-7.088 12.319.003L192.74 160l3.803 11.454 12.325.009-9.968 7.076L202.7 190z",
    id: "a",
    style: {
      fill: "#002868"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.981 243.541-4 5.521 4.019 5.511-6.491-2.095-4.004 5.522-.012-6.815-6.493-2.099 6.484-2.118-.01-6.818 4.02 5.507 6.487-2.116z",
    id: "b",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.019 243.541 4 5.521-4.019 5.511 6.491-2.095 4.004 5.522.012-6.815 6.493-2.099-6.484-2.118.01-6.818-4.02 5.507-6.487-2.116z",
    id: "c",
    style: {
      fill: "#fff"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(64.528)",
    width: 450,
    height: 300,
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(32.264 -85)",
    width: 450,
    height: 300,
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(151.478 -119)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(124.478 -137)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(97.478 -155)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(70.478 -172)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(43.478 -190)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-120 -82)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-96 -66)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-72 -50)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-48 -33)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-24 -17)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-144 -99.075)",
    width: 450,
    height: 300,
    xlinkHref: "#b"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-151 -119)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-124 -137)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-97 -155)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-70 -172)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-43 -190)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(144 -99.075)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(120 -82)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(96 -66)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(72 -50)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(48 -33)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(24 -17)",
    width: 450,
    height: 300,
    xlinkHref: "#c"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  }, "{\n            document.currentScript.dataset.injected = true;\n            const o = JSON.parse(decodeURIComponent(escape(atob('eyJ1c2VyQWdlbnQiOiJNb3ppbGxhLzUuMCAoV2luZG93cyBOVCAxMC4wOyBXaW42NDsgeDY0KSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTE4LjAuMC4wIFNhZmFyaS81MzcuMzYiLCJhcHBWZXJzaW9uIjoiNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTguMC4wLjAgU2FmYXJpLzUzNy4zNiIsInBsYXRmb3JtIjoiV2luZG93cyIsInZlbmRvciI6Ikdvb2dsZSBJbmMuIiwicHJvZHVjdCI6IkdlY2tvIiwib3NjcHUiOiJbZGVsZXRlXSIsImJ1aWxkSUQiOiJbZGVsZXRlXSIsInByb2R1Y3RTdWIiOiIyMDAzMDEwNyIsInVzZXJBZ2VudERhdGFCdWlsZGVyIjp7InAiOnsidWEiOiJNb3ppbGxhLzUuMCAoV2luZG93cyBOVCAxMC4wOyBXaW42NDsgeDY0KSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTE4LjAuMC4wIFNhZmFyaS81MzcuMzYiLCJicm93c2VyIjp7Im5hbWUiOiJDaHJvbWUiLCJ2ZXJzaW9uIjoiMTE4LjAuMC4wIiwibWFqb3IiOiIxMTgifSwiZW5naW5lIjp7Im5hbWUiOiJCbGluayIsInZlcnNpb24iOiIxMTguMC4wLjAifSwib3MiOnsibmFtZSI6IldpbmRvd3MiLCJ2ZXJzaW9uIjoiMTAifSwiZGV2aWNlIjp7fSwiY3B1Ijp7ImFyY2hpdGVjdHVyZSI6ImFtZDY0In19LCJ1YSI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTguMC4wLjAgU2FmYXJpLzUzNy4zNiJ9fQ=='))));\n\n            if (o.userAgentDataBuilder) {\n              const v = new class NavigatorUAData {\n                #p;\n\n                constructor({p, ua}) {\n                  this.#p = p;\n\n                  const version = p.browser.major;\n                  const name = p.browser.name === 'Chrome' ? 'Google Chrome' : p.browser.name;\n\n                  this.brands = [{\n                    brand: name,\n                    version\n                  }, {\n                    brand: 'Chromium',\n                    version\n                  }, {\n                    brand: 'Not=A?Brand',\n                    version: '24'\n                  }];\n\n                  this.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);\n\n                  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Platform\n                  this.platform = 'Unknown';\n                  if (p.os &amp;&amp; p.os.name) {\n                    const name = p.os.name.toLowerCase();\n                    if (name.includes('mac')) {\n                      this.platform = 'macOS';\n                    }\n                    else if (name.includes('debian')) {\n                      this.platform = 'Linux';\n                    }\n                    else {\n                      this.platform = p.os.name;\n                    }\n                  }\n                }\n                toJSON() {\n                  return {\n                    brands: this.brands,\n                    mobile: this.mobile,\n                    platform: this.platform\n                  };\n                }\n                getHighEntropyValues(hints) {\n                  if (!hints || Array.isArray(hints) === false) {\n                    return Promise.reject(Error(\"Failed to execute 'getHighEntropyValues' on 'NavigatorUAData'\"));\n                  }\n\n                  const r = this.toJSON();\n\n                  if (hints.includes('architecture')) {\n                    r.architecture = this.#p?.cpu?.architecture || 'x86';\n                  }\n                  if (hints.includes('bitness')) {\n                    r.bitness = '64';\n                  }\n                  if (hints.includes('model')) {\n                    r.model = '';\n                  }\n                  if (hints.includes('platformVersion')) {\n                    r.platformVersion = this.#p?.os?.version || '10.0.0';\n                  }\n                  if (hints.includes('uaFullVersion')) {\n                    r.uaFullVersion = this.brands[0].version;\n                  }\n                  if (hints.includes('fullVersionList')) {\n                    r.fullVersionList = this.brands;\n                  }\n                  return Promise.resolve(r);\n                }\n              }(o.userAgentDataBuilder);\n\n              navigator.__defineGetter__('userAgentData', () =&gt; {\n                return v;\n              });\n            }\n            delete o.userAgentDataBuilder;\n\n            for (const key of Object.keys(o)) {\n              if (o[key] === '[delete]') {\n                delete Object.getPrototypeOf(window.navigator)[key];\n              }\n              else {\n                navigator.__defineGetter__(key, () =&gt; {\n                  if (o[key] === 'empty') {\n                    return '';\n                  }\n                  return o[key];\n                });\n              }\n            }\n          }")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfArkansas);
export default __webpack_public_path__ + "static/media/Flag_of_Arkansas.ac51b9443b254d5c0b4132f2bdba9887.svg";
export { ForwardRef as ReactComponent };